import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import React, { Fragment, PureComponent, memo } from 'react';
import { Col, Text, Separator } from '@cuemath/comps';

import { openModal } from 'actions/modal';
import { InfoIcon, HomeworkIcon, LessonIcon, TestIcon } from 'comps/icon';
import MODAL from 'constants/modal';
import { HighlightedRow } from 'comps/styled-row';
import { NewWindowLink } from 'comps/cue-link';
import { suffixKeys, keyNames, tableKeys } from './data-keys';

const WorksheetSection = connect(
  null,
  dispatch => ({
    actions: bindActionCreators({ openModal }, dispatch),
  }),
)(
  memo(({ actions, worksheet }) => {
    const onInfoIconClick = () => {
      actions.openModal(
        'table',
        {
          size: 'custom',
          width: MODAL.WIDTH,
          height: MODAL.HEIGHT,
        },
        {
          tableData: worksheet,
          title: `Worksheet: ${worksheet.code}`,
          tableKeys,
          keyName: keyNames,
          suffixKeys,
        },
      );
    };

    return (
      <HighlightedRow backgroundColor="clear" alignItems="center" gap={4} gutter>
        <Col>
          {worksheet.type === 'HOMEWORK' ? (
            <HomeworkIcon size={14} />
          ) : (
            <LessonIcon size={14} />
          )}
        </Col>
        <Col gutter={4}>
          <Text>
            {worksheet.name} ({worksheet.code})
          </Text>
        </Col>
        <Col autoRight>
          <NewWindowLink
            href={`https://leap-teacher.cuemath.com/worksheet/${
              worksheet.id
            }/?activityReference=${worksheet.learnosity_reference}`}
            target="_blank"
          >
            <TestIcon size={14} />
          </NewWindowLink>
        </Col>
        <Col autoRight>
          <InfoIcon size={14} onClick={onInfoIconClick} />
        </Col>
      </HighlightedRow>
    );
  }),
);

export default class Worksheet extends PureComponent {
  static propTypes = {
    worksheet: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  render() {
    const { worksheet } = this.props;
    return (
      <Fragment>
        <WorksheetSection worksheet={worksheet} />
        <Separator />
      </Fragment>
    );
  }
}
